import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import PropTypes from 'prop-types'
// import PriceUtil from 'utils/price-util'
import CheckoutShipmentMethod from 'domains/customer-checkout/molecules/shipment-method'

const propTypes = {
  shipmentMethods      : PropTypes.arrayOf(PropTypes.object),
  chosenShipmentMethod : PropTypes.shape({
    id              : PropTypes.number,
    courier         : PropTypes.string,
    service_display : PropTypes.string,
    cost            : PropTypes.number
  }),
  onClickItem: PropTypes.func
}

const defaultProps ={
  shipmentMethods      : [],
  chosenShipmentMethod : {
    id      : '',
    courier : '',
    service : '',
    cost    : 0
  },
  onClickItem: () => {}
}
/**
 * @param {Array<Object>} shipmentMethods - array of shipment method objects
 * @param {number} chosenShipmentMethod - currently chosen shipment method
 * @param {Function} onClickItem - function that will set shipment method id state
 */
const CustomerOrderCourierSelectInput = ({
  shipmentMethods,
  chosenShipmentMethod,
  onClickItem
}) => (
  <ListGroup>
    {
      shipmentMethods.map((shipMethod) => {
        const errorMessages         = shipMethod?.error_messages
        const isEmptyErrorMessage   = Object.keys(errorMessages).length === 0
        const onClickShipmentMethod = () => {
          if (isEmptyErrorMessage) onClickItem(shipMethod)
          return
        }
        return (
          <ListGroupItem
            active={ shipMethod.id === chosenShipmentMethod?.id }
            key={ `shipment-method-courier-dropdown-item-${shipMethod.id}` }
            onClick={ onClickShipmentMethod }
          >
            <CheckoutShipmentMethod shipmentMethod={ shipMethod } />
          </ListGroupItem>
        )
      })
    }
  </ListGroup>
)

CustomerOrderCourierSelectInput.propTypes    = propTypes
CustomerOrderCourierSelectInput.defaultProps = defaultProps

export default CustomerOrderCourierSelectInput